import React from 'react';

export default function PortsInterfacesExplanation() {
    const [selectedSection, setSelectedSection] = React.useState('definition');

    return (
        <div className="p-6 max-w-6xl mx-auto">
            <div className="grid grid-cols-2 gap-6">
                <div className="space-y-4">
                    <h2 className="text-2xl font-bold mb-4">Ports (Interfaces)</h2>
                    
                    <div className="mb-4 flex space-x-2">
                        {['definition', 'structure', 'examples', 'implementation'].map(section => (
                            <button
                                key={section}
                                onClick={() => setSelectedSection(section)}
                                className={`px-4 py-2 rounded ${
                                    selectedSection === section
                                        ? 'bg-blue-500 text-white'
                                        : 'bg-gray-100'
                                }`}
                            >
                                {section.charAt(0).toUpperCase() + section.slice(1)}
                            </button>
                        ))}
                    </div>

                    {selectedSection === 'definition' && (
                        <div className="bg-white rounded-lg p-4 shadow">
                            <h3 className="text-lg font-semibold mb-2">Qu'est-ce qu'un Port ?</h3>
                            <ul className="space-y-2 list-disc list-inside text-gray-700">
                                <li>Définit les contrats des opérations</li>
                                <li>Isole le domaine de l'infrastructure</li>
                                <li>Permet l'inversion des dépendances</li>
                                <li>Facilite les tests et la maintenance</li>
                                <li>Assure la cohérence du système</li>
                            </ul>
                        </div>
                    )}

                    {selectedSection === 'structure' && (
                        <div className="bg-white rounded-lg p-4 shadow">
                            <h3 className="text-lg font-semibold mb-2">Types de Ports</h3>
                            <div className="space-y-4">
                                <div className="p-2 bg-gray-50 rounded">
                                    <h4 className="font-medium text-blue-600">1. Primary Ports (Input)</h4>
                                    <pre className="text-xs mt-2 whitespace-pre-wrap">
                                        {`public interface PaymentUseCase {
    PaymentResult processPayment(PaymentCommand command);
    Optional<Payment> getPayment(UUID id);
    List<Payment> findByStatus(PaymentStatus status);
}`}
                                    </pre>
                                </div>

                                <div className="p-2 bg-gray-50 rounded">
                                    <h4 className="font-medium text-blue-600">2. Secondary Ports (Output)</h4>
                                    <pre className="text-xs mt-2 whitespace-pre-wrap">
                                        {`public interface PaymentGatewayPort {
    GatewayResult sendPayment(Payment payment);
    GatewayStatus checkStatus(String reference);
    void cancelPayment(String reference);
}`}
                                    </pre>
                                </div>
                            </div>
                        </div>
                    )}

                    {selectedSection === 'examples' && (
                        <div className="bg-white rounded-lg p-4 shadow">
                            <h3 className="text-lg font-semibold mb-2">Exemples de Ports</h3>
                            <div className="space-y-4">
                                <div className="p-2 bg-gray-50 rounded">
                                    <h4 className="font-medium">Repository Port</h4>
                                    <pre className="text-xs mt-2 whitespace-pre-wrap">
                                        {`public interface PaymentRepository {
    Payment save(Payment payment);
    Optional<Payment> findById(UUID id);
    List<Payment> findByStatus(PaymentStatus status);
}`}
                                    </pre>
                                </div>

                                <div className="p-2 bg-gray-50 rounded">
                                    <h4 className="font-medium">Notification Port</h4>
                                    <pre className="text-xs mt-2 whitespace-pre-wrap">
                                        {`public interface NotificationPort {
    void sendNotification(NotificationRequest request);
    NotificationStatus getStatus(String notificationId);
}`}
                                    </pre>
                                </div>
                            </div>
                        </div>
                    )}

                    {selectedSection === 'implementation' && (
                        <div className="bg-white rounded-lg p-4 shadow">
                            <h3 className="text-lg font-semibold mb-2">Implementation</h3>
                            <div className="space-y-4">
                                <div className="p-2 bg-gray-50 rounded">
                                    <h4 className="font-medium">Repository Implementation</h4>
                                    <pre className="text-xs mt-2 whitespace-pre-wrap">
                                        {`@Component
public class JpaPaymentRepository implements PaymentRepository {
    private final JpaRepository repository;
    private final PaymentMapper mapper;

    @Override
    public Payment save(Payment payment) {
        PaymentEntity entity = mapper.toEntity(payment);
        return mapper.toDomain(repository.save(entity));
    }
}`}
                                    </pre>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="bg-white rounded-lg p-4 shadow">
                    <h3 className="text-xl font-bold mb-4">Bonnes Pratiques</h3>
                    <div className="space-y-4">
                        <div className="border-l-4 border-blue-500 pl-4">
                            <h4 className="font-semibold">1. Interface Ségrégation</h4>
                            <p className="text-sm text-gray-600">
                                Interfaces petites et spécifiques
                            </p>
                        </div>

                        <div className="border-l-4 border-green-500 pl-4">
                            <h4 className="font-semibold">2. Cohérence</h4>
                            <p className="text-sm text-gray-600">
                                Contrats clairs et cohérents
                            </p>
                        </div>

                        <div className="border-l-4 border-purple-500 pl-4">
                            <h4 className="font-semibold">3. Découplage</h4>
                            <p className="text-sm text-gray-600">
                                Isolation du domaine et de l'infrastructure
                            </p>
                        </div>

                        <div className="border-l-4 border-yellow-500 pl-4">
                            <h4 className="font-semibold">4. Testabilité</h4>
                            <p className="text-sm text-gray-600">
                                Facilité de mock et test
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}